import ControllerBase from '../../../../global/js/ControllerBase';
import { createPopper } from '@popperjs/core';


/** ControllerMarkerImage DOM references */
type ComponentMarkerImageRefs = {
	markerImage: 'markerImage'
};

export default class ControllerMarkerImage extends ControllerBase<ComponentMarkerImageRefs> {

	constructor(element: HTMLElement) {
		super(element, []);
		this.init();
	}

	private init() {

		const markerImage = this.$element.firstElementChild as HTMLDivElement;
		const markerArray = markerImage.querySelectorAll(".m-marker-image__marker");
		const tooltipArray = markerImage.querySelectorAll(".m-marker-image__tooltip");

		markerArray.forEach((marker, i) => {
			const tooltip = tooltipArray[i] as HTMLElement;
			const popperInstance = createPopper(marker, tooltip, {
				placement: 'right',
				modifiers: [
					{
						name: 'offset',
						options: {
							offset: [0, 20],
						},
					},
				],
			});

			marker.addEventListener('click', (e) => {
				markerArray?.forEach((item, j) => {
					if (item != e.target) {
						item.classList.remove("selected");
						tooltipArray[j].removeAttribute('data-show');
					}
				});
				marker.classList.toggle("selected");
				if (tooltip.attributes.getNamedItem("data-show")) {
					tooltip.removeAttribute('data-show');
				} else {
					tooltip.setAttribute('data-show', '');
					popperInstance.update();
				}
			});

		});
	}
}
